<template>
  <div class="grid grid-cols-1 lg:grid-cols-detail m-4 md:mx-8 md:mt-16 gap-8">
    <section class="w-full rounded">
      <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
        <h2>{{ $t("lang.msg.clientData") }}</h2>
      </div>
      <form class="bg-white p-4 space-y-4 rounded-b">
        <InputWrapper :label="$t('lang.fields.name')" content="input" block>
          <InputText v-model="newItem.clientName" :name="$t('lang.fields.name')" />
        </InputWrapper>
        <InputWrapper :label="$t('lang.fields.abbreviation')" content="input" block>
          <InputText v-model="newItem.abbreviation" :name="$t('lang.fields.abbreviation')" />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.group')" content="input" block>
          <Select
            id="idGroup"
            :data="groups"
            track-by="groupName"
            v-model.number="newItem.idGroup"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.chargingMethod')" content="input" block>
          <Select
            id="idFormaCobro"
            :data="chargingMethods"
            :track-by="getLangLabel('cobroNombre')"
            v-model.number="newItem.idFormaCobro"
          />
        </InputWrapper>
        <InputWrapper
          v-if="newItem.idClient"
          :label="$t('lang.msg.suppliers')"
          content="input"
          block
        >
          <multiselect
            v-model="newItem.suppliers"
            :options="suppliers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :taggable="true"
            tag-placeholder="Escriba para añadir un proveedor"
            placeholder="Escriba para buscar proveedores"
            label="supplierName"
            track-by="idSupplier"
            select-label="Pulse enter para seleccionar"
            deselect-label="Pulse enter para eliminar"
            @select="storeSupplier"
            @remove="removeSupplier"
          />
        </InputWrapper>
        <AdminToggleButton v-model="newItem.active" />

        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-primario hover:bg-primario text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Clients/Add`, `api/Clients/Update`)"
            @keyup.enter="addOrEditItem(`api/Clients/Add`, `api/Clients/Update`)"
          >{{ newItem.idClient == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
      </form>
    </section>

    <div class="flex flex-col w-full space-y-8" v-if="newItem.idClient">
      <section>
        <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
          <h2 class="flex items-center space-x-2">
            <router-link :to="{ name: 'adminSuppliers'}">
              PROVEEDORES
            </router-link>
            <IconExternalLink />
          </h2>
        </div>
        <div class="bg-white px-4 pb-2 rounded-b divide-y-2">
          <div
            v-for="(item, index) in newItem.suppliers"
            :key="`item_${index}`"
            class="py-4 grid grid-cols-1 lg:grid-cols-2 gap-2"
          >
            <InputWrapper :label="$t('lang.fields.name')" block>
              {{ item.supplierName }}
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.cif')" block>
              {{ item.supplierCif }}
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.address')" block>
              {{ item.supplierDirection }}
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.location')" block>
              {{ item.supplierUbication }}
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.phone')" block>
              {{ item.supplierPhone }}
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.email')" block>
              {{ item.supplierMail }}
            </InputWrapper>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "ClientDetail",
  components: {
    Multiselect
  },
  data() {
    return {
      idClient: this.$route.params.idClient,
      newItem: {},
      isModalOpen: false,
      groups: [],
      suppliers: [],
      chargingMethods: []
    }
  },
  created() {
    if (this.$route.params.idClient) {
      this.idClient = parseInt(this.$route.params.idClient);
      this.isEditing = true;

      this.fetchOneClient();
    }

    this.fetchGroups();
    this.fetchSuppliers();
    this.fetchChargingMethods();
  },
  methods: {
    fetchOneClient() {
      this.$axios.post("api/Clients/GetThisClient", {
        idClient: parseInt(this.idClient)  
      }).then((response) => {
        this.newItem = response.data || {};

        this.fetchClientSuppliers();
      });
    },
    fetchGroups() {
      this.$axios.get("api/Groups/GetGroups").then((response) => {
        this.groups = this.getActive(response.data, 'active');
      });
    },
    fetchChargingMethods() {
      this.$axios.get(`api/FormaCobroes/GetAll`).then((response) => {
        this.chargingMethods = this.getActive(response.data, 'active');
      });
    },
    fetchSuppliers() {
      this.$axios.get(`api/Suppliers/GetSupplier`).then(response => {
        this.suppliers = response.data
      });
    },
    fetchClientSuppliers() {
      this.$axios.post(`api/Suppliers/GetThisSupplierClient`, {
        idClient: this.newItem.idClient
      }).then(response => {
        this.$set(this.newItem, 'suppliers', response.data)
      });
    },
    storeSupplier(item) {
      this.$axios.post(`api/Suppliers/AddSuppliers`, {
        idSupplier: item.idSupplier,
        idClient: this.newItem.idClient
      }).then(() => {
        this.fetchClientSuppliers();
      });
    },
    removeSupplier(item) {
      this.$axios.post(`api/Suppliers/DeleteSupplierClient`, item);
    },
    openCreateModal() {
      this.newItem = {};
      this.isEditing = false;
      this.isModalOpen = true;
    },
    openEditModal(item) {
      this.newItem = { ...item };
      this.fetchClientSuppliers(this.newItem.idUser);

      this.isEditing = true;
      this.isModalOpen = true;
    },
    addOrEditItem(addURL, editUrl) {
      let url = "";
      let message = "";

      if (this.isEditing) {
        message = "Registro actualizado con éxito";
        url = editUrl;
      } else {
        message = "Registro añadido con éxito";
        url = addURL;
      }

      this.$axios.post(url, this.newItem).then(() => {
        this.openAlert('success', message, null);
        if (!this.$route.params.idClient) {
          this.$router.push({ name: "adminClients" });
        }
      });
    }
  }
}
</script>

<style></style>